'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactHookForm = require('react-hook-form');
var Checkbox = require('@circlefin/components/lib/Checkbox');

/**
 * Create Form Checkbox.
 */ function createFormCheckbox() {
    const FormCheckbox = ({ name, onChange, ...props })=>{
        const { field, fieldState } = reactHookForm.useController({
            name
        });
        const { isSubmitting } = reactHookForm.useFormState();
        const disabled = react.useMemo(()=>isSubmitting || props.disabled, [
            isSubmitting,
            props.disabled
        ]);
        const handleChange = react.useCallback((event)=>{
            onChange?.(event);
            field.onChange(event);
        }, [
            field,
            onChange
        ]);
        return jsxRuntime.jsx(Checkbox.Checkbox, {
            ...props,
            ...field,
            checked: field.value,
            disabled: disabled,
            error: fieldState.invalid,
            onChange: handleChange
        });
    };
    FormCheckbox.displayName = 'Form.Checkbox';
    return FormCheckbox;
}

exports.createFormCheckbox = createFormCheckbox;
//# sourceMappingURL=Form.Checkbox.js.map
